export default __webpack_public_path__ + "static/media/prof.4aa4e4da.gif";